import type { CrowdexCollaboration, CrowdexUIMessage } from '@crowdex/agent-contracts';

export type CachedConversation = {
  id: string;
  agentId?: string;
  title: string;
  /** Explicit execution owner; never derived from workspaceRoot. */
  runtime?: 'local' | 'worktree' | 'cloud';
  workspaceRoot: string | null;
  collaboration?: CrowdexCollaboration;
  modelId?: string;
  messages: CrowdexUIMessage[];
  updatedAt: number;
  restoredMessageCount: number | null;
  messageRevision: number;
};

export function transcriptEntry(message: { role: string; parts: unknown }): {
  role: string;
  text: string;
} {
  const parts = Array.isArray(message.parts) ? message.parts : [];
  const text = parts
    .flatMap((part) => {
      if (part === null || typeof part !== 'object') return [];
      const candidate = part as Record<string, unknown>;
      if (candidate['type'] === 'text' && typeof candidate['text'] === 'string') {
        return [candidate['text']];
      }
      return [];
    })
    .join('\n\n');
  return { role: message.role, text };
}
